module.exports = __webpack_public_path__ + "img/home-AttendanceConsole2.09d98970.png";